import React, { useEffect, useState } from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CheckoutButton } from './CheckoutButton';
import { checkoutUrl, productImage } from '../data/content';
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 30,
    seconds: 5
  });
  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeLeft(current => {
        if (current.seconds > 0) return {
          ...current,
          seconds: current.seconds - 1
        };
        if (current.minutes > 0) return {
          ...current,
          minutes: current.minutes - 1,
          seconds: 59
        };
        if (current.hours > 0) return {
          hours: current.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return {
          hours: 1,
          minutes: 30,
          seconds: 5
        };
      });
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  return <section id="pricing" className="scroll-mt-2 bg-brand-black px-4 py-6 text-white sm:px-6" aria-labelledby="offer-heading" data-id="element-124" data-mp="2xkhxqvedl1es">
      <div className="mb-3 text-center" data-id="element-125" data-mp="2sqwvgr5r1l9s">
        <p className="mb-1 font-heading text-[10px] font-semibold uppercase tracking-widest text-brand-gold" data-id="element-126" data-mp="32k2kbc33c76p">
          Special Offer — Complete 6-in-1 System
        </p>
        <h2 id="offer-heading" className="mb-1 text-2xl leading-none text-white sm:text-4xl" data-id="element-127" data-mp="2susp3ncya8ed">
          🥊 BOXING COACH PRO™
        </h2>
        <p className="mb-2 text-xs leading-snug text-white/75 sm:text-sm" data-id="element-128" data-mp="2xskiklt8u2ko">
          Get instant access today and completely transform the way you plan, organize, and deliver
          your boxing coaching sessions.
        </p>
        <p className="mb-2 font-heading text-xs font-semibold text-white sm:text-sm" data-id="element-129" data-mp="2ou8pmd4wmsp2">
          Complete 6-in-1 Operating System + 5 Premium Bonuses
        </p>
        <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="block" data-id="element-130" data-mp="2evt0gfpftti7">
          <img src={productImage} alt="Boxing Coach Pro complete system" className="mx-auto w-full max-w-[220px] rounded-xl object-contain shadow-[0_16px_36px_rgba(0,0,0,0.5)] transition-transform duration-200 hover:scale-[1.02]" data-id="element-131" data-mp="841yf3nepw2w" />
        </a>
      </div>
      <div className="mx-auto max-w-md rounded-2xl border-2 border-brand-gold bg-white p-3.5 text-center text-brand-ink shadow-2xl" data-id="element-132" data-mp="6mv6nu2n6zq9">
        <p className="font-heading text-xs font-semibold text-brand-muted" data-id="element-133" data-mp="1ojuvdssef5e">
          Regular Price: <span className="line-through" data-id="element-134" data-mp="3ttf3okt47nv4">$97</span>
        </p>
        <p className="mt-1 font-heading text-sm font-semibold text-brand-red" data-id="element-135" data-mp="ud8okrriji74">
          🔥 72% OFF — LIMITED-TIME LAUNCH OFFER
        </p>
        <p className="my-1 text-4xl leading-none text-brand-ink sm:text-5xl" data-id="element-136" data-mp="pe5vm5ot52fi">TODAY ONLY: $27 USD</p>
        <p className="text-[10px] text-brand-muted" data-id="element-137" data-mp="klcs1l52s050">Pay securely in your local currency.</p>
        <div className="my-3 rounded-xl border border-brand-red/25 bg-brand-red/5 p-2" data-id="element-138" data-mp="gksvaioeyyje">
          <p className="mb-1.5 font-heading text-[11px] font-semibold leading-tight text-brand-red" data-id="element-139" data-mp="1d4082m57soz8">
            🔥 Last Chance! This special price expires when the countdown reaches zero.
          </p>
          <div className="flex justify-center gap-2" data-id="element-140" data-mp="2r0jnmb15xt01">
            <TimeBox label="HOURS" value={timeLeft.hours} data-id="element-141" data-mp="2vy1ode5111wy" />
            <span className="pt-1 text-lg font-bold" data-id="element-142" data-mp="2vyl7uzabryd3">:</span>
            <TimeBox label="MINUTES" value={timeLeft.minutes} data-id="element-143" data-mp="2zzn7vic2geg4" />
            <span className="pt-1 text-lg font-bold" data-id="element-144" data-mp="3029cpa7kofun">:</span>
            <TimeBox label="SECONDS" value={timeLeft.seconds} data-id="element-145" data-mp="350kpntt5z6h3" />
          </div>
        </div>
        <CheckoutButton data-id="element-146" data-mp="39xb3eahhxpzc">🚀 YES! I WANT MY COMPLETE 6-IN-1 SYSTEM</CheckoutButton>
        <div className="mt-2 flex flex-col items-center justify-center gap-1 font-heading text-[11px] font-semibold text-brand-ink sm:flex-row sm:gap-4" data-id="element-147" data-mp="3ewdxizvxubsj">
          <span data-id="element-148" data-mp="3jq9srukthkk0">⭐ 4.9/5 — Verified Coach Reviews</span>
          <span className="flex items-center gap-1" data-id="element-149" data-mp="3nofwsuu9tm18">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-brand-red" aria-hidden="true" data-id="element-150" data-mp="3soltipfedyq6" />
            7-Day Money-Back Guarantee — Zero Risk
          </span>
        </div>
      </div>
    </section>;
}
function TimeBox({
  label,
  value
}: {
  label: string;
  value: number;
}) {
  return <div data-id="element-151" data-mp="3jyv9b9953bs0">
      <div className="rounded-lg bg-brand-black px-2 py-1 font-heading text-lg font-bold leading-none text-white" data-id="element-152" data-mp="3jylkvq3qtcof">
        {String(value).padStart(2, '0')}
      </div>
      <p className="mt-0.5 font-heading text-[8px] font-semibold tracking-wide text-brand-muted" data-id="element-153" data-mp="3tq85ue5vuq4d">
        {label}
      </p>
    </div>;
}